import { request } from "@/services/network";

export async function getUserCertificates(username) {
	return request({
		url: `/auth/users/${encodeURIComponent(username)}/certificates/`,
		method: "GET",
	}).then((data) => {
		return {
			certificates: data,
		};
	});
}

export async function getCertificateByID(id) {
	return request({
		url: `/certificates/${encodeURIComponent(id)}`,
		method: "GET",
	}).then((data) => {
		return {
			certificate: data,
		};
	});
}

export async function getCourseCertificate(slug) {
	return request({
		url: `/courses/${encodeURIComponent(slug)}/certificate/`,
		method: "GET",
	}).then((data) => {
		return {
			certificate: data,
		};
	});
}
